import type { Brand } from '@rock/types';

/** Reduce a URL/host to a bare, lowercased domain for comparison ("https://www.ge.com/" → "ge.com"). */
function bareDomain(raw: string): string {
    const host = raw
        .trim()
        .replace(/^[a-z]+:\/\//i, '')
        .split(/[/?#]/)[0]!
        .toLowerCase();
    return host.startsWith('www.') ? host.slice(4) : host;
}

/**
 * True when `brand.website` still points at the same company Brandfetch enriched from. Diverges when
 * `website` was hand-edited after the fact (editing Website never re-points `brandfetch` — see
 * `BrandDao.updateBrandDetails`), or when a brand has never been enriched at all.
 */
export function isDomainAlignedWithBrandfetch(brand: Pick<Brand, 'website' | 'brandfetch'>): boolean {
    if (!brand.website || !brand.brandfetch) return false;
    return bareDomain(brand.website) === bareDomain(brand.brandfetch.domain);
}
